import { render, staticRenderFns } from "./SingleUpdateModal.vue?vue&type=template&id=e879d39c&"
import script from "./SingleUpdateModal.vue?vue&type=script&lang=js&"
export * from "./SingleUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports